export const COLUMNS =[
    {
        Header      : '#',
        accessor    : 'orgCode',
        Cell            : e=><div className="text-center">{e.value}</div>,
        disableFilters:true
    },
    {
        Header      : 'Organization Name',
        accessor    : 'orgName',

        Cell: (row) => {
            /* Add data-tip */
            return <span data-tip={row.value}>{row.value.length >15 ?row.value.slice(0,14)+"..." :row.value}</span>;
          }
    },
    {
        Header      : 'Type of Certification',
        accessor    : 'typeOfCertification',
        disableFilters:true
    },
    {
        Header      : 'RFQ',
        accessor    : 'rfqlist',
        Cell            : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/viewrfq/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'Contract Review',
        accessor    : 'contractlist',
        Cell            : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/view/contractreview/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
   
    {
        Header      : 'Audit Agreement',
        accessor    : 'agreementlist',
        Cell        : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/view/viewauditagreements/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'Audit Team Proposal',
        accessor    : 'auditteamlist',
        Cell        : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/viewauditteamproposal/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
   
    {
        Header      : 'Audit Plan',
        accessor    : 'auditplanlist',
        Cell        : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/viewauditplan/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },   
    {
        Header      : 'Audit Observation',
        accessor    : 'auditobservationlist',
        Cell        : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/viewauditobservation/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'Review Audit',
        accessor    : 'auditreviewlist',
        Cell        : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/viewreviewofauditprocesses/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'Attendance List',
        accessor    : 'attendencelist',
        Cell        : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/view/viewattendancesheet/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'Audit Report',
        accessor    : 'stageoneauditreportlist',
        Cell        : e=><div className="text-center"><a href={'/admin/viewofstage1auditReport/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'Ems Report',
        accessor    : 'emsstage1auditreportlist',
        // Cell        : e=><div className="text-center"><a href={'/admin/ViewofEmsStage1AuditReport/'+(e.value).split("-")[1]}> {'View'} </a></div>,
       // Cell        : e=><div className="text-center"><a href={'/admin/viewofstage1auditReport/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'Ohsms Report',
        accessor    : 'ohsmsstage1auditreportlist',
        //Cell        : e=><div className="text-center"><a href={'/admin/viewofstage1auditReport/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'IMS All Report',
        accessor    : 'imsallstage1auditreportlist',
       // Cell        : e=><div className="text-center"><a href={'/admin/Viewofimsnew90011400145001stage1auditreport/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
]